import {
    DIC
} from '@/const/dic'
import {
    validateChinese
} from '@/util/validate'


// 菜单名称：1-30 位且需包含中文。先判空，避免 value 为 undefined 时读取 length 抛错
const validateName = (rule, value, callback) => {
    const val = (value || '').toString().trim()
    if (!val) {
        callback(new Error('请输入菜单名称'))
        return
    }
    if (!validateChinese(val) || val.length > 30) {
        callback(new Error('菜单名称为 1-30 位，且需包含中文'))
        return
    }
    callback()
}

// 路径必须是完整前端路由（/ 开头）或 http(s) 外链，否则菜单点击会白屏或跳 404
const validateUri = (rule, value, callback) => {
    const val = (value || '').toString().trim()
    if (!val) {
        callback(new Error('请输入路径'))
        return
    }
    if (/[\u4e00-\u9fa5]/.test(val)) {
        callback(new Error('路径不能包含中文'))
        return
    }
    if (!/^(\/|https?:\/\/)/.test(val)) {
        callback(new Error('路径需以 / 开头，或使用 http(s):// 开头的外部链接'))
        return
    }
    if (val.length > 200) {
        callback(new Error('路径长度不能超过 200 个字符'))
        return
    }
    callback()
}

// 权限值用于后端鉴权比对，必须英文字母开头，避免填错导致菜单权限静默失效
const validatePermission = (rule, value, callback) => {
    const val = (value || '').toString().trim()
    if (!val) {
        callback(new Error('请输入权限值'))
        return
    }
    if (!/^[A-Za-z][A-Za-z0-9_]*$/.test(val)) {
        callback(new Error('权限值只能包含字母、数字和下划线，且以字母开头'))
        return
    }
    callback()
}

export const menuTableOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: true,
    menuWidth: '200',
    labelWidth: '120',
    // 新增/编辑/查看弹窗：点击遮罩不关闭，避免误触丢失已填内容
    dialogClickModal: false,
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "菜单名称",
            prop: "name",
            placeholder: "请输入菜单名称",
            search: true,
            type: 'input',
            rules: [{
                required: true,
                trigger: "blur",
                validator: validateName
            }]
        },{
            label: "上级菜单",
            prop: "superiorId",
            placeholder: "请选择上级菜单",
            solt: true,
            formsolt: true
        },
        {
            label: "菜单类型",
            prop: "type",
            formsolt: true,
            // 表格按字典显示中文；表单仍走 typeForm 自定义下拉插槽
            dicData: DIC.MENU_TYPE,
        },
        {
            label: "路径",
            prop: "uri",
            placeholder: "请输入路径，如 /salesCloud/shop",
            type: 'input',
            rules: [{
                required: true,
                trigger: "blur",
                validator: validateUri
            }]
        },
        {
            label: "图标",
            prop: "icon",
            placeholder: "点击右侧按钮选择，或直接输入 el-icon-xxx",
            type: 'input',
            // 表格直接渲染图标；表单走 iconForm 插槽，提供可视化图标选择器
            solt: true,
            formsolt: true,
            rules: [{
                required: true,
                trigger: "change",
                message: "请选择或输入图标"
            }]
        },
        {
            label: "权限值",
            prop: "permissionValue",
            placeholder: "如 JOINS_SALES_CLOUD_SHOP",
            type: 'input',
            rules: [{
                required: true,
                trigger: "blur",
                validator: validatePermission
            }]
        },
        {
            label: "是否为公开菜单",
            prop: "isPublicMenu",
            type: "radio",
            hide: true,
            dicData: DIC.DELETE_FLAG
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "创建人",
            prop: "createBy",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "状态",
            prop: "status",
            type: "radio",
            addVisdiplay: false,
            editVisdiplay: false,
            dicData: DIC.STATUS_STATE_MODEL
        },
        {
            label: "更新时间",
            prop: "updateTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "更新人",
            prop: "updateBy",
            type: "input",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "是否删除",
            prop: "deleteFlag",
            type: "radio",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            dicData: DIC.DELETE_FLAG
        },
        {
            label: "备注",
            prop: "remarks",
            type: "textarea",
            hide: true,
            max: 255
        }


    ]
};
